import { render } from "./SectionFinal.vue?vue&type=template&id=12efc78d&scoped=true"
import script from "./SectionFinal.vue?vue&type=script&lang=js"
export * from "./SectionFinal.vue?vue&type=script&lang=js"

import "./SectionFinal.vue?vue&type=style&index=0&id=12efc78d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12efc78d"]])

export default __exports__